import { createRef, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
//import { useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import ReCAPTCHA from "react-google-recaptcha";
import useValidator from "../../hooks/useValidator";
import ButtonClose from "../../modules/homeout/principal/components/modal/ButtonClose";
import TagManager from "react-gtm-module";
import SpinnerCuadrado from "../../modules/helpers/SpinnerCuadrado";
import {
  getSession,
  postLogin,
  postRegister,
  postUpdate,
} from "../../services/serviceVivetuseguro";
import {
  encodeBase64,
  encryptDecrypt,
} from "../../modules/helpers/validations";
import sha256 from "sha256";
import * as CryptoJS from "crypto-js";
//import SidebarLogin from "./SidebarLogin";

const SidebarActivarCuenta = (props) => {
  const handleClose = () => props.close(false);

  //const navigate = useNavigate()

  //const [mostrarLogin, setMostrarLogin] = useState(false)

  // RECAPTCHA
  const recaptchaRef = useRef();
  const [loading, setLoading] = useState(false);
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [validarEmail, setValidarEmail] = useState(false);
  const [validarCelular, setValidarCelular] = useState(false);
  const [validarRFC, setValidarRFC] = useState(false)
  const [validarPass, setValidarPass] = useState(false);
  const [validarCheck, setValidarCheck] = useState(false);
  const [exiteEmail, setExiteEmail] = useState(false);
  const [textAlerta, setTextAlerta] = useState("");

  const [form, setForm] = useState({
    email: '',
    celular: '',
    rfc: '',
    tipoIdentificacion: '5',
    password: '',
  });

  const { formValidador, error } = useValidator(form.password);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const gotoLogin = () => {
    handleClose();
    props.setShowLogin(true);
  };

  const handleSubmit = async () => {
    setExiteEmail(false);
    const emailRegex =
      /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

    if (form.email === "" && form.password === "") {
      setExiteEmail(true);
      return setTextAlerta("Para continuar debes completar todos los campos.");
    }

    if (!emailRegex.test(form.email)) {
      return setValidarEmail(true);
    }
    setValidarEmail(false);

    if (form.celular === "") {
      setValidarCelular(true);
      return;
    }
    setValidarCelular(false);

    if (form.rfc === '') {
      setValidarRFC(true)
      return;
    }
    setValidarRFC(false)

    if (form.password === '') {
      setExiteEmail(true);
      setTextAlerta("La contraseña no cumple con los caracteres requeridos ");
      setValidarPass(true);
      return;
    }
    setValidarPass(false);

    if (error) {
      setExiteEmail(true);
      setTextAlerta("La contraseña no cumple con los caracteres requeridos! ");
      return;
    }
    setExiteEmail(false);

    if (validarCheck == false) {
      setExiteEmail(true);
      setTextAlerta("Debe aceptar los términos y condiciones");
      return;
    }
    setExiteEmail(false);

    if (form.email !== "" && form.celular !== "" && !error) {
      // // Genero un token y en caso de error limpio la variable para un siguiente intento
      let token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      let tokenUpdate = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      let tokenLogin = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();

      setLoading(true);

      if (!token) {
        setExiteEmail(true);
        setTextAlerta("Captcha inválido, actualizar web");
        return;
      }

      let datos = {
        identificacion: form.email,
        email: form.email,
        celular: form.celular,
        tipoIdentificacion: parseInt(form.tipoIdentificacion),
        tokenCaptcha: token,
      };

      try {
        postRegister(datos, urlApi).then((rpta) => {
          if (rpta.Mensaje == "Usuario existente") {
            setTextAlerta("Ya existe un usuario con este correo y/o celular.");
            setExiteEmail(true);
            setLoading(false);
            // // setMensaje('Ya existe un usuario con este documento.');
            // TagManager.dataLayer({
            //     dataLayer: {
            //         event: 'formRegistro',
            //         category: 'Etapas de Registro',
            //         action: 'Paso 1',
            //         label: rpta.Mensaje,
            //     }
            // })
          } else if (rpta.Codigo === 1) {
            setTextAlerta(rpta.Mensaje);
            setExiteEmail(true);
            setLoading(false);
          } else if (rpta.Codigo === 2) {
            // setMensaje(rpta.Mensaje);
            setTextAlerta(rpta.Mensaje);
            setExiteEmail(true);
            setLoading(false);
          } else if (rpta.Codigo === 4) {
            setTextAlerta(
              "Información ingresada no corresponde a la registrada. Inténtelo de nuevo."
            );
            setExiteEmail(true);
          } else if (rpta.Codigo === 0) {
            setLoading(false);
            // **************************************
            // Contuinuar con el alta
            // navigate('/registro/2')

            let saltPassword = btoa(
              encryptDecrypt(
                sha256(form.password),
                tokenUpdate.substring(
                  tokenUpdate.length - 10,
                  tokenUpdate.length
                )
              )
            );

            let datosUpdate = {
              clave: saltPassword,
              email: rpta.user.email ? rpta.user.email : "",
              fono: rpta.user.fono ? rpta.user.fono : "",
              idusuario: rpta.user.idusuario,
              tokenCaptcha: tokenUpdate,
            };
            // ****************

            postUpdate(datosUpdate, urlApi).then(async (res) => {
              // if (res.Codigo === 1 || res.Codigo === 2) {
              //     setMensaje(res.Mensaje)
              //     setLoading(false)
              //     TagManager.dataLayer({
              //         dataLayer: {
              //             event: 'formRegistro',
              //             category: 'Etapas de Registro',
              //             action: 'Paso 2',
              //             label: res.Mensaje,
              //         }
              //     })
              // }
              // else if (res.Codigo === 0) {
              //     setMensaje('')
              //     TagManager.dataLayer({
              //         dataLayer: {
              //             event: 'formRegistro',
              //             category: 'Etapas de Registro',
              //             action: 'Paso 2',
              //             label: 'Satisfactorio',
              //             userId: rpta.user.identificacion,
              //             userMail: datosUpdate.email
              //         }
              //     })

              //     // PASO 3:....
              //     // navigate('/registro/3')
              //     // ***************************

              let objUsuario = {
                usuario: rpta.user.email,
                password: encodeBase64(
                  encryptDecrypt(
                    sha256(form.password),
                    tokenLogin.substring(
                      tokenLogin.length - 10,
                      tokenLogin.length
                    )
                  )
                ),
                sitioPassword: "9B9CB6631B27AA1DF47DB351B497004810015B09",
                sitioUsuario: "CARDIF",
                deviceInfo: "",
                tokenCaptcha: tokenLogin,
              };

              recaptchaRef.current.reset();
              postLogin(objUsuario, urlApi).then((rpta) => {
                if (rpta.codigo === 0) {
                  localStorage.setItem(
                    "token",
                    CryptoJS.AES.encrypt(
                      rpta.data.token,
                      "8f6391895c404ab68eb7a8e42eb73587"
                    )
                  );

                  window.dataLayer.push({
                    event: `CET_LANCPI_REGISTROEXITOSO`,
                    action: `BTN_ACTIVATUCUENTA`,
                  });

                  getSession(rpta.data.token, urlApi).then((data) => {
                    let res = { data }.data;
                    localStorage.setItem(
                      "user",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(res),
                        "8f6391895c404ab68eb7a8e42eb73587"
                      )
                    );

                    setLoading(false);

                    let urlVivetuseguro =
                      props.infoApi[0].urlFront + rpta.data.token;
                    window.open(urlVivetuseguro, "_blank");
                  });
                }
              });
              // }
            });
          }
          setLoading(false);
        });
      } catch (err) {
        TagManager.dataLayer({
          dataLayer: {
            event: "formRegistro",
            category: "Etapas de Registro",
            action: "Paso 1",
            label: "Error",
          },
        });

        setLoading(false);

        setMensaje("Error en el registro");
      }
    } else {
      setExiteEmail(true);
      setMensaje("Para continuar debes completar todos los campos.");
    }
  };

  useEffect(() => {
    if (props.infoApi?.length < 1 || props.infoApi === undefined) return;
    props.infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [props.infoApi]);

  return (
    <>
      {loading && <SpinnerCuadrado />}

      <Offcanvas
        show={props.show}
        onHide={handleClose}
        className="modal__activa-cuenta"
        placement="end"
      >
        <div className=" d-none d-lg-block">
          <ButtonClose close={handleClose} />
        </div>
        <div
          className="d-lg-none  d-flex justify-content-end  "
          style={{ fontSize: "20px" }}
        >
          <div
            className="center_center borde_verde text-verde cursor rounded-5 mt-4 me-4 "
            onClick={handleClose}
            style={{ width: "30px", height: "30px" }}
          >
            x
          </div>
        </div>
        <Offcanvas.Body className="p-0">
          <div className="sticky__btn__sidebar_up  d-none d-lg-block ">
            <button
              className="btn__sidebar_up "
              type="button"
              onClick={handleClose}
            >
              <b>
                INGRESA A TU
                <br />
                ECOSISTEMA AQUÍ
              </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <i className="fa-solid fa-angle-down flecha__sticky__btn"></i>
            </button>
          </div>

          <div className="col-12 text-center ">
            <h1 className="modal__activa-cuenta__title mb-5">
              ¡Activar tu cuenta es muy sencillo!
            </h1>
          </div>
          <div className="col-12 modal__activa-cuenta__body">
            <blockquote className="Leelawadee">
              <p className="h4 d-none d-lg-block">
                Inicia sesión y continua disfrutando de tus beneficios
                adicionales
              </p>
              <p className="h4 d-lg-none">
                Complete los datos a continuación para comenzar a activar su
                cuenta:
              </p>
            </blockquote>

            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="form__modal"
            >
              <div className="row justify-content-center">
                {exiteEmail && (
                  <div
                    class="alert text-center bg-rojo w-100 text-white fs-4"
                    role="alert"
                  >
                    {textAlerta}
                  </div>
                )}
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-input "
                    id="email"
                    name="email"
                    placeholder="E-mail"
                    autoComplete="off"
                    value={form.email}
                    onChange={handleChange}
                  />
                  {validarEmail && (
                    <p className="text-danger h6 ">Ingrese un email válido</p>
                  )}
                </div>

                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-input "
                    id="celular"
                    name="celular"
                    placeholder="Celular"
                    autoComplete="off"
                    value={form.celular}
                    onChange={handleChange}
                  />
                  {validarCelular && <p className="text-danger h6 ">Ingrese un teléfono válido</p>}
                </div>

                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-input "
                    id="rfc"
                    name="rfc"
                    placeholder="RFC"
                    autoComplete="off"
                    value={form.rfc}
                    onChange={handleChange}
                  />
                  {validarRFC && <p className="text-danger h6 ">Ingrese un RFC válido</p>}
                </div>

                <div className="col-12">
                  <input
                    maxLength={16}
                    type="password"
                    className="form-control border-input "
                    id="password"
                    name="password"
                    placeholder="Contraseña"
                    autoComplete="off"
                    value={form.password}
                    onChange={handleChange}
                  />
                  {validarPass && (
                    <p className="text-danger h6 ">Ingrese un Contraseña</p>
                  )}
                </div>
                <div className="col-12 px-5  ">{formValidador()}</div>

                <div className="col-12 mt-4 pb-3 px-4 d-flex">
                  <input
                    type="checkbox"
                    className="activa__checkbox"
                    onChange={(e) => setValidarCheck(e.target.checked)}
                  />
                  <label className="activa__label">
                    He leído y acepto las condiciones de uso.
                  </label>
                </div>
                <div className="col-12 mt-1 text-center">
                  <div className="d-none d-lg-block">
                    <button
                      className="btn__azul fw-bold "
                      onClick={handleSubmit}
                    >
                      CONTINUAR
                    </button>
                  </div>
                  <div className="d-lg-none">
                    <button
                      className="btn__azul fw-bold "
                      onClick={handleSubmit}
                    >
                      ACTIVAR CUENTA
                    </button>
                  </div>
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={codRecaptcha}
                  />
                </div>
                <div className="text-center footer__register mt-5">
                  <p className="h3 d-none d-lg-block">
                    <span
                      role="button"
                      className="text-decoration-underline"
                      onClick={gotoLogin}
                    >
                      Ya tengo una cuenta
                    </span>
                  </p>
                  <p className="h3 d-lg-none">
                    <span role="button" className="cursor" onClick={gotoLogin}>
                      Ya tengo una cuenta
                    </span>
                  </p>
                </div>
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarActivarCuenta;
